// extracted by mini-css-extract-plugin
export default {"header":"styles_header__WJhF8","title":"styles_title__b2H-w","row":"styles_row__HKzto"};